import React, { ReactElement, ReactNode } from "react"
import Button from "@material-ui/core/Button"
import clsx from "clsx"
import { CountDown } from "./CountDown"
import { Gift } from "./icons"
import close_hint from "../../../../images/icons/icon_hint_black.svg"
import hint_icon_white from "../../../../images/icons/u_exclamation-circle.svg"
import * as styles from "./rightSection.module.scss"
import { ItemTooltip } from "../../../ItemTooltip"
import { handleClickHeader } from "../../../../helpers/WatcherDL/utils/handleClickHeader"
import { DLClickEventExtended } from "../../../../helpers/WatcherDL/DLEvents"
import scrollToPersonalForm from "../../../../helpers/scrollToPersonalForm"
import { WhiteGift } from "./icons/WhiteGift"

type Props = {
  withoutHintAndCountDown?: boolean
  onlyGift?: boolean
  showHint?: boolean
  hasCTA?: boolean
  countDownTime: number
  buttonText?: string
  newYear?: boolean
  hint?: ReactNode
  hintTitle?: ReactElement | string
  background?: string
  isCountdown?: boolean
  variantStyles?: string
  urlForButtonRedirect?: string
  withScrollOnClickCountDown?: boolean
}

const defaultHintTitle = (
  <>
    Халва.Десятка <br /> в подарок
  </>
)
const defaultHint =
  "Оформите карту «Халва» сейчас и получите подписку «Халва.Десятка» в подарок. Раскройте все возможности Халвы по максимуму!"

const textBeforeTooltipNewYear = (
  <>
    Участвуй в<br /> розыгрыше
  </>
)

export const RightSection = ({
  withoutHintAndCountDown = false,
  onlyGift,
  showHint,
  hasCTA,
  countDownTime,
  buttonText,
  newYear,
  hint = defaultHint,
  hintTitle = defaultHintTitle,
  background,
  isCountdown,
  variantStyles,
  urlForButtonRedirect,
  withScrollOnClickCountDown,
}: Props) => {
  const whiteColorAndIcons = variantStyles === "pravdaCoffee"
  return (
    <div className={clsx(styles.container, variantStyles && styles[variantStyles])}>
      {!withoutHintAndCountDown && (
        <>
          {!onlyGift && (
            <div className={styles.halvaTenContainer}>
              {newYear ? (
                <ItemTooltip
                  hint={hint}
                  leftPosition="-100px"
                  className={{ icon: styles.hintNY }}
                  showHint={showHint}
                  icon={close_hint}
                  hasCTA={hasCTA}
                  textBeforeTooltip={textBeforeTooltipNewYear}
                  variantStyle={variantStyles}
                >
                  {textBeforeTooltipNewYear}
                </ItemTooltip>
              ) : (
                <ItemTooltip
                  hint={hint}
                  leftPosition="-100px"
                  className={{ icon: styles.hint }}
                  showHint={showHint}
                  hasCTA={hasCTA}
                  icon={whiteColorAndIcons ? hint_icon_white : close_hint}
                  textBeforeTooltip={hintTitle}
                  variantStyle={variantStyles}
                >
                  {hintTitle}
                </ItemTooltip>
              )}
            </div>
          )}
          {isCountdown && (
            <>
              {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
              <div
                className={clsx(
                  styles.countdown_container,
                  withScrollOnClickCountDown && styles.pointer
                )}
                onKeyDown={() => {}}
                onClick={() => {
                  if (withScrollOnClickCountDown) {
                    DLClickEventExtended({
                      eventAction: "Халва.Десятка в подарок",
                      name: "Tooltip",
                      placement: "header",
                    })
                    scrollToPersonalForm()
                  }
                }}
              >
                {whiteColorAndIcons ? <WhiteGift /> : <Gift />}
                <CountDown countDownTime={countDownTime} />
              </div>
            </>
          )}
        </>
      )}

      <Button
        style={{ background }}
        classes={{ root: styles.btn }}
        onClick={() => handleClickHeader("sticky", "header", urlForButtonRedirect)}
      >
        {buttonText}
      </Button>
    </div>
  )
}
